import { Component, input, Input } from '@angular/core';
import { ShortenNumberPipe } from '../pipes/shorten-number.pipe';
import { Author, Manga } from '../interfaces/manga.interfaces';

@Component({
  selector: 'app-manga-info',
  imports: [ShortenNumberPipe],
  templateUrl: './manga-info.component.html',
  styleUrl: './manga-info.component.css'
})
export class MangaInfoComponent {
  @Input() author!: Author;
  @Input() manga!: Manga;

  showDetails: boolean = true;

  toggleDetails() {
    this.showDetails = !this.showDetails;
  } 
}